module.exports = __webpack_public_path__ + "img/followup_bannernew.4484a2fd.png";